import { postWithAuth } from '../InitializeService';
import { AxiosInstance } from 'axios';
export type ConflictBehaviors = 'overwrite' | 'fail' | 'rename'; 
export type DocumentBody = {
    file: File;
    siteUrl: string, //https://sharepoint.teampbs.com
    libraryName: string,
    folderPath?: string,
    overwrite: boolean,
    conflictBehavior?: ConflictBehaviors,
    metadata: Record<string, any>
}
export const postDocumentWithMetadata = (instance: AxiosInstance, body: DocumentBody) => {
    const formData = new FormData();
    
    // Add the required fields
    formData.append('file', body.file);
    formData.append('siteUrl', body.siteUrl);
    formData.append('libraryName', body.libraryName);
    formData.append('overwrite', body.overwrite.toString());
    formData.append('conflictBehavior', body.conflictBehavior ?? '');
    // Add optional folderPath if provided
    if (body.folderPath) {
        formData.append('folderPath', body.folderPath);
    }
    
    // Add metadata fields as individual form fields
    Object.keys(body.metadata).forEach(key => {
        if (body.metadata[key] !== null && body.metadata[key] !== undefined) {
            formData.append(key, body.metadata[key].toString());
        }
    });
    
    return postWithAuth('sharepoint/documents', formData, instance);
}